import gsap from 'gsap';

function init( node ) {
	if ( ! ( node instanceof HTMLElement ) ) {
		return;
	}

	const diamondImg = node.querySelector( '.diamond-feature__image' );
	const textColumns = node.querySelectorAll( '.diamond-feature__text' );

	const tl = gsap.timeline( {
		defaults: {
			duration: 1,
			ease: 'power2.inOut',
		},
		scrollTrigger: {
			trigger: node,
			start: '20% center',
		},
	} );

	gsap.set( diamondImg, {
		visibility: 'visible',
		opacity: 0,
		rotation: -25,
		scale: 0.75,
		x: 0,
	} );

	gsap.set( textColumns, {
		visibility: 'visible',
		opacity: 0,
		y: '10%',
	} );

	tl.to( diamondImg, {
		scale: 1,
		rotation: 10,
		x: '10%',
		opacity: 1,
		duration: 1.25,
	} ).to( textColumns, {
		opacity: 1,
		duration: 1,
		y: 0,
		stagger: 0.1,
		ease: 'power2.out',
	} );
}

document.querySelectorAll( '.diamond-feature' ).forEach( init );
